<!-- Alert -->
<fuse-alert
    class="auth-fuse-alert forgot-password-alert"
    *ngIf="showAlert"
    [appearance]="'outline'"
    [showIcon]="false"
    [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{ alert.message }}
</fuse-alert>

<!-- Forgot password form -->
<form
    class="auth-form-wrapper-deep forgot-password-form"
    [formGroup]="forgotPasswordForm"
    #forgotPasswordNgForm="ngForm">
    <!-- Email field -->
    <mat-form-field class="auth-form-field forgot-password-form-field">
        <mat-label>Email address</mat-label>
        <input
            id="username"
            matInput
            [formControlName]="'username'" />
        <mat-error
            *ngIf="forgotPasswordForm.get('username').hasError('required')">
            Please enter your email address to reset your password
        </mat-error>
        <mat-error *ngIf="forgotPasswordForm.get('username').hasError('email')">
            Please enter a valid email address
        </mat-error>
    </mat-form-field>

    <!-- Submit button -->
    <button
        class="auth-form-submit-button forgot-password-form-submit-button fuse-mat-button-large"
        mat-flat-button
        [color]="'primary'"
        [disabled]="forgotPasswordForm.disabled || !forgotPasswordForm.valid"
        (click)="sendResetLink()">
        <span *ngIf="!forgotPasswordForm.disabled">Send password reset email</span>
        <mat-progress-spinner
            *ngIf="forgotPasswordForm.disabled"
            [diameter]="24"
            [mode]="'indeterminate'"></mat-progress-spinner>
    </button>

    <!-- Form footer -->
    <div class="auth-footer forgot-password-form-footer">
        <span>Return to</span>
        <a
            id="return-to-sign-in"
            class="auth-footer-link forgot-password-form-footer-link"
            (click)="goBackToSignIn()">
            sign in
        </a>
    </div>
</form>
